import { cn } from "@/lib/utils";

export const panelClass =
  "bg-card text-card-foreground rounded-lg border border-border shadow-card";

export const rowClass =
  "bg-surface-subtle rounded-row border border-border px-3.5 py-3 transition-[border-color,box-shadow] hover:border-line-strong hover:shadow-card-hover";

export const sectionLabelClass =
  "text-[11px] font-bold uppercase tracking-wider text-muted-foreground";

export const AppMark = ({
  className,
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md";
}) => (
  <div
    className={cn(
      "flex shrink-0 items-center justify-center rounded-[10px] bg-gradient-to-br from-app-mark-from to-app-mark-to font-semibold text-white",
      size === "sm" ? "size-8 text-[10px]" : "size-10 text-xs",
      className,
    )}
    aria-hidden
  >
    PT
  </div>
);
